import { MantineProviders } from "./MantineProviders";
import { Providers as MainProviders } from "./Providers";

export const Providers = {
  Mantine: MantineProviders,
  Main: MainProviders
};
